import {Fragment} from "react";
import classNames from "classnames";
import WithOutLocation from "./WithOutLocation";
import AddressControl from "../../../../form/AddressControl";
import React from "react";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems} = props;
    return (hidden || []).indexOf("pos") === -1 && <Fragment>
        <div className={classNames({"col-md-3": props.values.pos, "col-md-12": !props.values.pos})}>
            <WithOutLocation {...propsTop} />
        </div>
        {props.values.pos && props.values.pos.location &&
        <div className={"col-md-9"}>
            <div className={"row"}>
                <AddressControl disabled={"disabled"} name="pos.location.address" value={ props.values.pos.location.address } label="Cím" saveChanges={ props.setFieldValue }/>
            </div>
        </div>
        }
    </Fragment>;
}